module.exports = __webpack_public_path__ + "img/sell_01.2769877b.png";